import { SVGProps } from 'react'

export const TimeSvg = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version='1.1'
      viewBox='0 0 1024 1024'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M798.72 322.56L865.28 256c15.36-15.36 15.36-35.84 0-51.2-15.36-15.36-35.84-15.36-51.2 0l-71.68 71.68C686.08 230.4 614.4 204.8 542.72 199.68V122.88h56.32c20.48 0 35.84-15.36 35.84-35.84 0-20.48-15.36-35.84-35.84-35.84H419.84c-20.48 0-35.84 20.48-35.84 35.84 0 20.48 15.36 35.84 35.84 35.84h56.32v71.68c-215.04 20.48-373.76 209.92-353.28 424.96s209.92 373.76 424.96 353.28c215.04-20.48 373.76-209.92 353.28-424.96-10.24-81.92-46.08-163.84-102.4-225.28zM512 901.12c-174.08 0-317.44-143.36-317.44-317.44C194.56 409.6 337.92 266.24 512 266.24c174.08 0 317.44 143.36 317.44 317.44 0 174.08-143.36 317.44-317.44 317.44z m122.88-225.28c10.24 15.36 10.24 35.84-5.12 51.2-15.36 10.24-35.84 10.24-51.2-5.12l-92.16-117.76c-5.12-5.12-10.24-15.36-10.24-20.48V419.84c0-20.48 15.36-35.84 35.84-35.84s35.84 15.36 35.84 35.84v153.6l87.04 102.4z' />
    </svg>
  )
}
